/* eslint-disable react/prop-types */
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = Boolean(localStorage.getItem('currentuser')); // Replace with your auth logic

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
